
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The creation date & time that resulting webhook subscriptions must succeed.`}</p>
    <p>{`This can be used to initiate the retrieval of paginated results.
Subsequent queries should use the opaque cursors returned from `}<a parentName="p" {...{
        "href": "/schema/named-type/WebhookSubscriptionsConnection",
        "title": "A page of webhook subscriptions"
      }}><inlineCode parentName="a">{`WebhookSubscriptionsConnection`}</inlineCode></a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;